import './style.scss'; 
 
import React, { FC } from 'react';
import makeAnimated from 'react-select/animated';
import Select from 'react-select'

const animatedComponents = makeAnimated();

interface Props {
  options?: any;
  closeMenuOnSelect?: boolean;
  label?: string;
  className?: string;
  placeholder?: string;
  isMulti?: boolean;
  onChange?: any
  value?: any
}
const MultipleSelect: FC<Props> = ({
  closeMenuOnSelect = false,
  options,
  label,
 className,
 onChange,
 isMulti = true,
 placeholder = "Choisir",
 value
}: Props) => {
  return ( 
    <div className={`MultipleSelect ${className}`}>
      <label>
        {label}
      </label>
      <Select
        onChange={onChange}
        closeMenuOnSelect={closeMenuOnSelect}
        components={animatedComponents}
        isMulti={isMulti}
        options={options}
        placeholder={placeholder}
        value={value}
        styles={{
          multiValueLabel: (base) => ({
            ...base,
            backgroundColor: "#2f62ae",
            color: 'white',
            padding: "8px"
          }),
          input: (base) => ({
            ...base,
            padding: "8px 0px",
          }),
          option: (base) => ({
            ...base,
            cursor: "pointer"
          }),
          placeholder: (base) => ({
            ...base,
            color: "text-primary"
          }),
          container: (base) => ({
            ...base,
            padding: 1,
          }),
          dropdownIndicator: (base) => ({
            ...base,
            color: "#2f62ae"
          }),
          clearIndicator: (base) => ({
            ...base,
            color: "#2f62ae"
          }),
          control: (base) => ({
            ...base,
            borderColor: "#2f62ae",
          }),
        }}
      />
    </div> 
  ); 
} 
 
export default MultipleSelect; 
